module.exports = __webpack_public_path__ + "img/0Q3B7497_WoodMatted.67c77351.jpg";